@if (showSnack()) {
<div class="snackbar-main">
  <div class="snackbar-wrapper">
    <div class="snack-message" [innerHTML]="message()"></div>
    <button class="snackbar-action" (click)="closeBtn()">{{ buttonText() }}</button>
  </div>
</div>
}
